import React, { Component } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import IframeResizer from 'react-iframe-resizer-super'

import styles from './Html.module.css'

class HtmlParagraph extends Component {
  iframeUrl = ({ targetId, entity }) => {
    const fragments = entity.url.split('files/')

    return `${fragments[0]}files/filefield_embed_html/${targetId}/index.html`
  }

  render() {
    const iframeResizerOptions = {
      checkOrigin: false,
      autoResize: false,
      scrolling: true,
    }

    const { html } = this.props

    const url = this.iframeUrl(html)

    return (
      url && (
        <div className={styles.wrapper}>
          <IframeResizer
            src={url}
            iframeResizerOptions={iframeResizerOptions}
            className={styles.iframe}
          />
        </div>
      )
    )
  }
}

HtmlParagraph.propTypes = {
  html: PropTypes.shape({
    entity: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
    targetId: PropTypes.number.isRequired,
  }),
}

const fragments = {
  paragraph: gql`
    fragment HtmlParagraphFragment on ParagraphHtml {
      id
      html: fieldEmbedHtml {
        targetId
        entity {
          url
        }
      }
      description: fieldParagraphDescription {
        value
      }
      caption: fieldParagraphCaption {
        value
      }
      credits: fieldParagraphCredits {
        value
      }
      creditsLabel: fieldParagraphCreditsLabel
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { HtmlParagraph, fragments }
